// extracted by mini-css-extract-plugin
export default {"tabs":"Zpio4v","selected":"DhAfNS","breakpointsPreviewBar":"zYfDfA","width":"n6JjoV","widthTitle":"J9210N","divider":"JZwirb"};